var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "M4.231 13.135A6.45 6.45 0 0 0 7.507 14a6.44 6.44 0 0 0 3.262-.865 6.8 6.8 0 0 0 2.366-2.366A6.4 6.4 0 0 0 14 7.507a6.36 6.36 0 0 0-.865-3.261q-.887-1.501-2.366-2.366A6.3 6.3 0 0 0 7.507 1a6.3 6.3 0 0 0-3.276.88 6.55 6.55 0 0 0-2.367 2.366A6.36 6.36 0 0 0 1 7.507c0 1.184.288 2.26.864 3.262a6.8 6.8 0 0 0 2.367 2.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M8.912 3.128c.5.246.901.607 1.238 1.067.339.459.5.951.5 1.492 0 .263-.033.51-.113.739-.08.23-.16.41-.258.558a2.3 2.3 0 0 1-.386.427c-.177.163-.321.262-.417.328-.113.066-.258.147-.451.262a1.44 1.44 0 0 0-.482.46q-.194.27-.193.443a.3.3 0 0 1-.08.213.3.3 0 0 1-.21.082H6.34a.3.3 0 0 1-.21-.082.32.32 0 0 1-.08-.213v-.328c0-.41.16-.788.467-1.15.321-.36.659-.622 1.045-.787.29-.147.482-.279.611-.41a.9.9 0 0 0 .177-.558q0-.32-.338-.541a1.28 1.28 0 0 0-.772-.247 1.43 1.43 0 0 0-.772.214c-.193.147-.45.443-.772.853a.28.28 0 0 1-.225.115.24.24 0 0 1-.16-.065l-1.19-.92c-.129-.098-.161-.23-.065-.377C4.812 3.406 5.92 2.75 7.385 2.75c.514 0 1.029.132 1.527.378M6.1 10.295c0-.082.032-.164.08-.213A.3.3 0 0 1 6.39 10h1.72c.08 0 .16.033.209.082s.08.13.08.213v1.74a.32.32 0 0 1-.08.213.3.3 0 0 1-.209.082H6.39a.3.3 0 0 1-.21-.082.32.32 0 0 1-.08-.213z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionSmall);
export default __webpack_public_path__ + "static/media/question-small.6f5b3562158b81242719ebd241c8a969.svg";
export { ForwardRef as ReactComponent };